
// 已打开的tabs
export const getHomeTabs = state => {
    return state.homeTabs;
};

// 菜单
export const getMenu = state => {
    return state.menu;
};

// 当前tab
export const getHomeCurrentTab = state => {
    return state.homeCurrentTab;
};

// 已打开的tabs
export const getTabIndex = state => {
    return state.tabIndex;
};

// 当前打开的targetName
export const getTabTargetName = state => {
    return state.homeCurrentTab;
};

// 获取sockekt数据
export const getSocketData = state => {
    return state.socketData;
};

// 获取权限值
export const getPermission = state => {
    return state.permission;
};

export const getOrderManageData = state => {
    return state.orderManageData;
};


// WEBPACK FOOTER //
// ./src/store/getters.js